<template>
  <div class="bind-teacher">
    <el-dialog title="绑定教师" :visible="bindTeacherShow" width="40%" @close="dialogClose" @open="dialogOpen">
      <el-form :inline="true">
        <el-form-item label="职务名称" label-width="100px">
          <el-input v-model="jobItemData.jobName" autocomplete="off" placeholder="请输入职务名称" style="width: 235px"
            :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <el-form @submit.native.prevent>
        <el-form-item label="教师搜索" label-width="100px">
          <div class="notice-search">
            <search :placeholder="placeholder" @search="search" />
          </div>
        </el-form-item>
      </el-form>
      <div>绑定教师总人数：{{ bindTeacherList.length }} 名</div>
      <el-table ref="table" :data="bindTeacherList" style="width: 100%" height="350px">
        <el-table-column prop="teacherName" label="姓名" width="180"> </el-table-column>
        <el-table-column prop="teacherNumber" label="工号" width="180"> </el-table-column>
        <el-table-column prop="phone" label="手机号"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import search from "@/components/search/search.vue";
export default {
  name: "",
  props: ["bindTeacherShow", "jobItemData"],
  data() {
    return {
      selectList: [],
      placeholder: "请输入教师姓名",
      teacherName: "",
      teacherList: [],
      indexArray: [],
      bindTeacherList: []
    };
  },
  components: {
    search,
  },
  created() {
    this.selectTeacherListByAdminPC();
  },
  methods: {
    // 查询职务绑定教师列表
    getTeachersJobList() {
      this.bindTeacherList = [];
      this.get(this.$url.getTeachersJobList + "?jobId=" + this.jobItemData.id).then(
        (res) => {
          // console.log("查询当前职务绑定教师列表==>", res);

          // 遍历 ids 数组
          res.data.forEach(id => {
            // 使用 find 方法在 this.teacherList 数组中查找 id 匹配的对象
            const teacher = this.teacherList.find(t => t.id === id);
            // 如果找到匹配的对象，则将其添加到 bindTeacherList
            if (teacher) {
              this.bindTeacherList.push(teacher);
            }
          });
          // console.log(this.bindTeacherList);
        }
      );
    },
    selectTeacherListByAdminPC() {
      this.post(this.$url.selectTeacherListByAdminPC, {
        schoolId: this.user.schoolId,
        teacherName: this.teacherName,
      })
        .then((res) => {
          this.teacherList = res.rows;
          this.getTeachersJobList();
        })
        .catch((err) => {
          console.log("获取教师列表err==>", err);
        });
    },
    search(query) {
      this.teacherName = query;
      this.selectTeacherListByAdminPC();
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:bindTeacherShow", false);
    },
    dialogOpen() { },
  },
};
</script>

<style lang="scss" scoped>
@import "./bind-teacher-list.scss";
</style>
